import _ from 'lodash';

import { interpolate } from '../components/common/interpolate/interpolate';

import { getErrorDefinition } from './ErrorDefinition';
import Errors, { ErrorDetails, FormError, GlobalError } from './model/errors';

export const convertErrors = (errors: ErrorDetails[]): Errors => {
    const globalErrors = extractGlobalErrors(errors).map(convertToGlobalError);
    const formErrors = extractFormErrors(errors).map(convertToFormError);

    return new Errors(formErrors, globalErrors);
};

const extractGlobalErrors = (errors: ErrorDetails[]) => _.filter(errors, isGlobalError);

const isGlobalError = ({ field }: ErrorDetails) => !field;

const convertToGlobalError = ({ messageCode, messageParams }: ErrorDetails): GlobalError => {
    const messageTemplate = getMessageTemplate(messageCode);
    return { message: interpolate(messageTemplate, messageParams) };
};

const extractFormErrors = (errors: ErrorDetails[]): ErrorDetails[] => _.filter(errors, isFormError);

const isFormError = ({ field }: ErrorDetails): boolean => !!field;

const convertToFormError = ({ field, messageCode, messageParams }: ErrorDetails): FormError => {
    const messageTemplate = getMessageTemplate(messageCode);
    const argumentArray = [field, ...messageParams];
    return { field: field, message: interpolate(messageTemplate, argumentArray) };
};

const getMessageTemplate = (messageCode: string) => {
    return getErrorDefinition(messageCode).message;
};
